// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"121":"gallery","176":"projects","328":"admin","443":"about","597":"resume"}[chunkId] + "." + {"121":"156fed9b","176":"6b76463b","328":"2f81e42a","443":"e8ce7412","597":"4a44a60b"}[chunkId] + ".css";
};